<template>
    <span class="icon" v-bind:class="iconClass" v-bind:style="iconStyle" aria-hidden="true">
        <svg v-bind:height="width" v-bind:width="width"
             viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0h24v24H0z" fill="none" stroke="none"/>
            <keep-alive>
              <component v-bind:is="`i${name}`"/>
            </keep-alive>
        </svg>
    </span>
</template>

<script>
    import Star from "./Star"
    import Send from "./Send"
    import Facebook from "./Facebook"
    import FacebookFull from "./FacebookFull"
    import Twitter from "./Twitter"
    import Youtube from "./Youtube"
    import GooglePlus from "./GooglePlus"
    import GooglePlusBig from "./GooglePlusBig"
    import LinkedIn from "./LinkedIn"
    import Person from "./Person"
    import MyLocation from "./MyLocation"
    import Cancel from "./Cancel"
    import CancelO from "./CancelO"
    import ArrowUp from "./ArrowUp"
    import ArrowDown from "./ArrowDown"
    import Location from "./Location"
    import Filter from "./Filter"
    import ArrowRight from "./ArrowRight"
    import ArrowRight2 from "./ArrowRight2"
    import ArrowLeft from "./ArrowLeft"
    import Menu from "./Menu"
    import Search from "./Search"
    import Plus from "./Plus"
    import Minus from "./Minus"
    import Tune from "./Tune"
    import Sort from "./Sort"
    import Heart from "./Heart"
    import Health from "./Health"
    import Calendar from "./Calendar"
    import DoneFull from "./DoneFull"
    import CalendarBig from "./CalendarBig"
    import Clock from "./Clock"
    import Language from "./Language"
    import ZoomOut from "./ZoomOut"
    import TargetGroups from "./TargetGroups"
    import Public from "./Public"
    import Phone from "./Phone"
    import Mail from "./Mail"
    import Coaching from "./Coaching"
    import Gesundheit from "./Gesundheit"
    import Massage from "./Massage"
    import Ernaehrung from "./Ernaehrung"
    import Psychologie from "./Psychologie"
    import Bewegung from "./Bewegung"
    import Help from "./Help"
    import PostponedPay from "./PostponedPay"
    import CrossedDollar from "./CrossedDollar"
    import Guard from "./Guard"
    import Insurance from "./Insurance"
    import Office from "./Office"
    import Record from "./Record"
    import Done from "./Done"
    import ErrorIcon from "./Error"
    import Info from "./Info"
    import Info2 from "./Info2"
    import Warning from "./Warning"
    import TagLabel from "./TagLabel"
    import EditPencil from "./EditPencil"
    import Gallery from "./Gallery"
    import Review from "./Review"
    import CallUs from "./CallUs"
    import AboutMe from "./AboutMe"
    import Qualification from "./Qualification"
    import Languages from "./Languages"
    import Methods from "./Methods"
    import Symptoms from "./Symptoms"
    import Question from "./Question"
    import CommentIcon from "./Comment"
    import Pencil from "./Pencil"
    import TherapistImprove from "./TherapistImprove"
    import TherapistDiscover from "./TherapistDiscover"
    import TherapistOffer from "./TherapistOffer"
    import NotificationsActive from "./NotificationsActive"
    import Gender from "./Gender"
    import UserGroup from "./UserGroup"
    import Copy from "./Copy"

    const PADDING_RATIO = 0.38;

    export default {
        name: 'icon',
        components: {
          "istar": Star,
          "isend": Send,
          "ifacebook": Facebook,
          "ifacebook-full": FacebookFull,
          "itwitter": Twitter,
          "iyoutube": Youtube,
          "igoogle-plus": GooglePlus,
          "igoogle-plus-big": GooglePlusBig,
          "ilinked-in": LinkedIn,
          "iperson": Person,
          "imy-location": MyLocation,
          "icancel": Cancel,
          "icancel-o": CancelO,
          "iarrow-up": ArrowUp,
          "iarrow-down": ArrowDown,
          "ilocation": Location,
          "ifilter": Filter,
          "iarrow-right": ArrowRight,
          "iarrow-right-2": ArrowRight2,
          "iarrow-left": ArrowLeft,
          "imenu": Menu,
          "isearch": Search,
          "iplus": Plus,
          "iminus": Minus,
          "itune": Tune,
          "isort": Sort,
          "iheart": Heart,
          "ihealth": Health,
          "icalendar": Calendar,
          "idone-full": DoneFull,
          "icalendar-big": CalendarBig,
          "iclock": Clock,
          "ilanguage": Language,
          "izoom-out": ZoomOut,
          "itarget_groups": TargetGroups,
          "ipublic": Public,
          "iphone": Phone,
          "imail": Mail,
          "icoaching": Coaching,
          "igesundheit": Gesundheit,
          "imassage": Massage,
          "iernaehrung": Ernaehrung,
          "ipsychologie": Psychologie,
          "ibewegung": Bewegung,
          "ihelp": Help,
          "ipostponed-pay": PostponedPay,
          "icrossed-dollar": CrossedDollar,
          "iguard": Guard,
          "iinsurance": Insurance,
          "ioffice": Office,
          "irecord": Record,
          "idone": Done,
          "ierror": ErrorIcon,
          "iinfo": Info,
          "iinfo-2": Info2,
          "iwarning": Warning,
          "itag-label": TagLabel,
          "iedit-pencil": EditPencil,
          "igallery": Gallery,
          "ireview": Review,
          "icall-us": CallUs,
          "iabout-me": AboutMe,
          "iqualification": Qualification,
          "ilanguages": Languages,
          "imethods": Methods,
          "isymptoms": Symptoms,
          "iquestion": Question,
          "icomment": CommentIcon,
          "ipencil": Pencil,
          "itherapist-improve": TherapistImprove,
          "itherapist-discover": TherapistDiscover,
          "itherapist-offer": TherapistOffer,
          "inotifications-active": NotificationsActive,
          "igender": Gender,
          "iuser-group": UserGroup,
          "icopy": Copy,
        },
        props: {
            name: {
                type: String,
                required: true
            },
            color: {
                type: String
            },
            width: {
                type: Number,
                default: 24
            },
            circled: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            iconClass() {
                return {
                    'icon--default': !this.color,
                    'icon--primary': this.color === 'primary',
                    'icon--secondary': this.color === 'secondary',
                    'icon--yellow': this.color === 'yellow',
                    'icon--green': this.color === 'green',
                    'icon--grey': this.color === 'grey',
                    'icon--grey-2': this.color === 'grey-2',
                    'icon--black-grey': this.color === 'black-grey',
                    'icon--black': this.color === 'black',
                    'icon--white': this.color === 'white',
                    'icon--dark-grey': this.color === 'dark-grey',
                    'icon--dark-blue': this.color === 'dark-blue',
                    'icon--blue-3': this.color === 'blue-3',
                    'icon--aquamarine': this.color === 'aquamarine',
                    'icon--circled': this.circled === true
                };
            },
            iconStyle() {
                return {
                  padding: this.circled ? this.width * PADDING_RATIO + 'px' : null
                };
            }
        }
    }
</script>

<style lang="less">
    @import "../../less/variables.less";

    .icon {
        display: inline-block;
        vertical-align: middle;
        margin-top: auto;
        margin-bottom: auto;
        font-size: 0;
        line-height: 0;

        &--default {
            fill: @light-grey;
            border-color: @light-grey;
        }

        &--primary {
            fill: @primary;
            border-color: @primary;
        }

        &--secondary {
            fill: @secondary;
            border-color: @secondary;
        }

        &--yellow {
            fill: @yellow;
            border-color: @yellow;
        }

        &--green {
            fill: @green;
            border-color: @green;
        }

        &--grey {
            fill: @grey;
            border-color: @grey;
        }

        &--grey-2 {
            fill: @grey-2;
            border-color: @grey-2;
        }

        &--black-grey {
            fill: @black-grey;
            border-color: @black-grey;
        }

        &--black {
            fill: #000;
            border-color: #000;
        }

        &--white {
            fill: white;
            border-color: white;
        }

        &--aquamarine {
            fill: @aquamarine;
            border-color: @aquamarine;
        }

        &--dark-grey {
            fill: @dark-grey;
            border-color: @dark-grey;
        }

        &--dark-blue {
            fill: @dark-blue;
            border-color: @dark-blue;
        }

        &--blue-3 {
            fill: @blue-3;
            border-color: @blue-3;
        }

        &--circled {
            border-width: 2px;
            border-style: solid;
            -webkit-border-radius: 50%;
            -moz-border-radius: 50%;
            border-radius: 50%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/icon/Icon.vue